<template>
    
    <v-dialog
        :value="display"
        max-width="700"
        persistent
    >
        <MessageOverlay ref="overlay" @endSuccess="emitValid"/>
        <v-card >
            <v-card-title>
                <span class="text-h5">{{ $vuetify.lang.t('$vuetify.organization.delOrga.delOrga') }}</span>
            </v-card-title>
            <v-card-text class="px-2 px-sm-6">
                <v-form ref="form" v-model="deleteOrgaFormValidation" lazy-validation>
                    <v-text-field
                        v-model="deleteOrga.name"
                        name="Name"
                        :label="$vuetify.lang.t('$vuetify.organization.delOrga.name')"
                        type="text"
                        outlined
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="deleteOrga.orderNb"
                        outlined
                        required
                        :label="$vuetify.lang.t('$vuetify.organization.delOrga.orderNb')"
                        type="text"
                    ></v-text-field>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            :disabled="!deleteOrgaFormValidation"
                            :class="{ 'gradient-wintech': (deleteOrgaFormValidation) }"
                            @click="validDeleteOrganization"
                        >
                            <v-icon left>mdi-content-save</v-icon>
                            {{ $vuetify.lang.t('$vuetify.organization.delOrga.validate') }}
                        </v-btn>
                        <v-btn
                            color="error"
                            @click="cancelDeleteOrganization"
                        >
                            <v-icon left>mdi-cancel</v-icon>
                            {{ $vuetify.lang.t('$vuetify.organization.delOrga.cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import MessageOverlay from './../Overlay/MessageOverlay.vue';
export default {
    name: "DeleteOrganization",
    components: {MessageOverlay},
    props: {
        display: Boolean,
        iduProp: String
    },
    data() {
        return {
            deleteOrga: {
                name: "",
                orderNb: "",
            },
            deleteOrgaFormValidation: true,
        };
    },

    methods: {
        async validDeleteOrganization(){
            try {
                const res = await axios.delete('organizations/deleteOrganization/'+this.deleteOrga.name+'/'+this.deleteOrga.orderNb+'/'+this.iduProp);
                if(res.status == 200) { 
                    this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.organization.delOrga.delOrgaOK'))
                }
            } catch(error) {
                if ('response' in error && error.response.status === 403) {
                    this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.organization.delOrga.delOrgaNOK'))
                }
            }
        },
        cancelDeleteOrganization(){
            this.deleteOrga = {
                name: "",
                orderNb: "",
            },
            this.$emit("cancel");
        },
        emitValid(){
            this.deleteOrga = {
                name: "",
                orderNb: "",
            }
            this.$emit("valid");
        }

    },
};
</script>